<template>
    <div
        class="tabs-container"
        :class="{ visible }"
    >
        <div
            v-for="tab in tabs"
            :key="tab.type"
            class="q-pr-sm flex flex-center"
        >
            <q-badge
                :color="tab.color"
            >
                <q-icon
                    name="filter_alt"
                    class="q-mr-xs"
                    size="xs"
                />
                <span
                    class="q-pr-xs"
                >
                    {{ tab.title }}
                </span>
                <QTooltip>
                    <span
                        v-for="(item, index) in filtersByTab[tab.type]"
                        :key="index"
                        style="display: block;"
                    >
                        {{ formatSelection(item, allFilters, $t) }}
                    </span>
                </QTooltip>
            </q-badge>
        </div>
    </div>
</template>
<script>
import VueTypes from 'vue-types'
import { formatSelection } from '../utils'

const colors = {
    general: 'primary',
    dashboard: 'primary',
    own: 'secondary',
}

export default {
    name: 'FilterTabs',
    props: {
        graphFilters: VueTypes.oneOfType([VueTypes.object, VueTypes.string]),
        dashboardFilters: VueTypes.oneOfType([VueTypes.object, VueTypes.string, VueTypes.array]),
        generalFilters: VueTypes.object,
        allFilters: VueTypes.oneOfType([VueTypes.object, VueTypes.array]),
        visible: VueTypes.bool.def(false),
    },
    setup() {
        return {
            formatSelection,
        }
    },
    data() {
        return {
            tabs: [],
        }
    },
    computed: {
        filtersByTab() {
            return {
                general: this.generalFilters,
                dashboard: this.dashboardFilters,
                own: this.graphFilters,
            }
        },
    },
    watch: {
        generalFilters: {
            handler(newVal) {
                this.updateTabs('general', newVal)
            },
            immediate: true,
        },
        dashboardFilters: {
            handler(newVal) {
                this.updateTabs('dashboard', newVal)
            },
            immediate: true,
            deep: true,
        },
        graphFilters: {
            handler(newVal) {
                this.updateTabs('own', newVal)
            },
            immediate: true,
        },
    },
    methods: {
        updateTabs(type, filters) {
            const existingTab = this.tabs.find((tab) => tab.type === type)
            if (filters.length !== 0) {
                if (!existingTab) {
                    this.tabs.push({
                        type,
                        title: this.$t(`dashboards.filterTags.${type}`),
                        color: colors[type],
                    })
                }
            } else if (existingTab) {
                this.tabs = this.tabs.filter((tab) => tab.type !== type)
            }
            const order = ['general', 'dashboard', 'own']
            this.tabs.sort((a, b) => order.indexOf(a.type) - order.indexOf(b.type))
        },
    },
}
</script>
<style lang="scss">
.tabs-container {
  display: flex;
  margin-left: 10px;
  width: auto;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.tabs-container.visible {
  opacity: 100%;
  visibility: visible;
}
</style>
